import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  ReferenceField,
  ListActions,
  BooleanField,
  usePermissions,
  Filter,
  SearchInput,
  SelectInput,
} from "react-admin";
import { isInternalAdmin } from "../../auth-provider";

const ProjectFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <SelectInput
      source="isArchived"
      label="Archived"
      choices={[
        { id: "false", name: "Not archived" },
        { id: "true", name: "Archived" },
        { id: "all", name: "All" },
      ]}
      alwaysOn
    />
  </Filter>
);

export const ProjectList = ({ ...props }) => {
  const permissions = usePermissions();

  return (
    <List
      {...props}
      perPage={25}
      sort={{ field: "updated", order: "DESC" }}
      filters={<ProjectFilter />}
      filterDefaultValues={{ isArchived: "false" }}
      actions={isInternalAdmin(permissions.permissions) ? <ListActions /> : null}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="name" />
        <ReferenceField
          source="createdBy"
          reference="users"
          link={isInternalAdmin(permissions.permissions) ? "show" : false}
        >
          <TextField source="firstName" />
        </ReferenceField>
        <ReferenceField
          source="organisationId"
          reference="organisations"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField source="type" />
        <BooleanField source="archived" label="Archived" />
        <NumberField
          source="amountOfCompletedEmployees"
          label="Completed Employees"
        />
        <NumberField source="amountOfEmployees" label="Total Employees" />
        <TextField source="assessmentsSource" />
        <DateField source="startDateTime" />
        <DateField source="updated" />
        <TextField source="language" />
      </Datagrid>
    </List>
  );
};
